import { IsoDateStr, Maybe } from '@csp/csp-common-model';

export type ArchivingFilesQueryFilterCriteria = {
  fileName: string;
};

export type ArchivingFilesQueryFilterdateRangeCriteria = {
  startDate: Maybe<IsoDateStr>;
  endDate: Maybe<IsoDateStr>;
};

export type ArchivingFilesQueryFilter = {
  key: string;
  pageSize: number;
  criteria: Partial<ArchivingFilesQueryFilterCriteria>;
  dateRangeCriteria: ArchivingFilesQueryFilterdateRangeCriteria;
  count?: boolean;
};

export type PartialArchivingFilesQueryFilter = Partial<ArchivingFilesQueryFilter>;

export const EMPTY_ARCHIVING_FILES_QUERY_FILTER_CRITERIA: ArchivingFilesQueryFilterCriteria = {
  fileName: '',
};
